import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const deleteProjectEntry = {
    namespaced: true,
    state: {
        modalDeleteDataProjectEntry: {}
    },
    mutations: {
        SET_MODAL_DELETE_DATA_PROJECT_ENTRY(state, modalDeleteDataProjectEntry) {
            state.modalDeleteDataProjectEntry.textInfo  = modalDeleteDataProjectEntry.textInfo + " " + modalDeleteDataProjectEntry.id + " ?";
            state.modalDeleteDataProjectEntry = modalDeleteDataProjectEntry;
        },
        SUCCESS_DELETE_PROJECT_ENTRY(state, response) {
            let dataReceive = {
                title: response.message,
                text: response.data.data.textInfo
            };
            eventBus.$emit("deleteProjectReportEntrySuccess", dataReceive);
        },
        FAILURE_DELETE_PROJECT_ENTRY(state, error) {
            state.projectEntryDataReceive = {
                title: error.response.data.message,
                text: handleError(error) !== "" ? handleError(error) : error.response.data.data.message
            }
            eventBus.$emit("showSnackbarError", state.projectEntryDataReceive);
        }
    },
    actions: {
        setModalDeleteDataProjectEntry: function ({ commit }, modalDeleteData) {
            commit("SET_MODAL_DELETE_DATA_PROJECT_ENTRY", modalDeleteData);
        },
        removeProjectEntry: function ({ state, dispatch }) {
            let promise = sendRequest("delete", config.baseURLApi + "/projectReportEntries/" + state.modalDeleteDataProjectEntry.id);
            promise.then(function (result) {
                if(result[0] === "success") {
                    dispatch("successDeleteProjectEntry", result[1]);
                } else {
                    dispatch("failureDeleteProjectEntry", result[1]);
                }
            })
        },
        successDeleteProjectEntry: function ({ commit }, response) {
            commit("SUCCESS_DELETE_PROJECT_ENTRY", response);
        },
        failureDeleteProjectEntry: function ({ commit }, response) {
            commit("FAILURE_DELETE_PROJECT_ENTRY", response);
        }
    }
}

export default deleteProjectEntry;